import React from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getActiveSchool, setActiveSchool, isViewingDemoSchool } from '../utils/activeSchool';
import { getApiBaseUrl } from '../apiBase';

export default function DemoViewBanner({ onReturnToOwn }) {
    const { t } = useTranslation(['demoView', 'demoTour', 'schoolSwitcher', 'common']);
    const active = getActiveSchool();
    if (!isViewingDemoSchool()) return null;

    async function handleReturn() {
        if (onReturnToOwn) {
            onReturnToOwn();
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const api = axios.create({
                baseURL: getApiBaseUrl(),
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            const res = await api.get('/school/my/list');
            const owned = res.data || [];
            if (owned[0]) {
                setActiveSchool({
                    schoolId: owned[0].id,
                    schoolName: owned[0].name,
                    schoolLogo: owned[0].logo,
                    accessRole: 'owner',
                    studentId: null,
                    isDemoSchool: false
                });
                window.location.href = '/school';
                return;
            }
        } catch {
            /* fallback */
        }
        window.location.href = '/select-school';
    }

    const demoTag = t('demoTour:demoTag');
    const schoolLabel = active?.schoolName?.replace(` ${demoTag}`, '').replace(` (${demoTag})`, '') || t('schoolSwitcher:demoFallback');

    return (
        <div
            data-onboarding="demo-banner"
            style={{
                background: '#f5f7fb',
                borderBottom: '2px solid #C41E1E',
                padding: '10px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                flexWrap: 'wrap',
                zIndex: 900
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <span style={{ fontSize: 18 }}>👁</span>
                <div>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#EB3333' }}>
                        {t('demoView:bannerTitle')}
                    </div>
                    <div style={{ fontSize: 13, color: '#555' }}>
                        {t('demoView:bannerSub', { name: schoolLabel })}
                    </div>
                </div>
            </div>
            <button
                type="button"
                onClick={handleReturn}
                style={{
                    padding: '8px 14px',
                    borderRadius: 8,
                    border: '1px solid #C41E1E',
                    background: '#fff',
                    color: '#EB3333',
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontSize: 13,
                    whiteSpace: 'nowrap'
                }}
            >
                {t('demoView:returnOwn')}
            </button>
        </div>
    );
}

export { isViewingDemoSchool };
